import { Button } from 'antd';
import { AlignRightOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

const AlignRight = ({ editor, showLabel = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${editor.isActive({ textAlign: 'right' }) ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<AlignRightOutlined className="text-gray-800 text-xs" />}
      onClick={() => editor.chain().focus().setTextAlign('right').run()}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="ALIGN_RIGHT" defaultMessage="Align right" />
        </div>
      )}
    </Button>
  );
};

export default AlignRight;
